/* Kids store: light enhancement for Shopify's built-in policy pages (/policies/*).
   The page is fully readable without this script. */
(function () {
  const container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  const title = container.querySelector('.shopify-policy__title');
  if (title && !title.querySelector('.kids-policy__eyebrow')) {
    const eyebrow = document.createElement('p');
    eyebrow.className = 'kids-policy__eyebrow';
    eyebrow.textContent = 'Store policies';
    title.prepend(eyebrow);
  }

  if (!document.body.classList.contains('kids-policy--contact-information')) return;

  const rte = container.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  const icons = {
    trade:
      '<path d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="m4 7.5 8 4.5 8-4.5M12 12v9"/>',
    phone:
      '<path d="M5 3.5h3.5l1.7 4.3-2.2 1.4a11 11 0 0 0 6.8 6.8l1.4-2.2 4.3 1.7V19a2 2 0 0 1-2 2A16.5 16.5 0 0 1 3 5.5a2 2 0 0 1 2-2z"/>',
    email: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/>',
    address: '<path d="M12 21s-7-6.3-7-11.5a7 7 0 0 1 14 0C19 14.7 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
    hours: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    response: '<path d="M4 5h16v11H9l-5 4V5z"/><path d="M8 10h8M8 13h5"/>',
    other: '<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/>',
  };

  const paragraphs = Array.from(rte.querySelectorAll('p'))
    .map((p) => p.textContent.trim())
    .filter(Boolean);
  const isRow = (text) => /^[^:]{2,40}:\s*\S/.test(text);
  const rows = paragraphs.filter(isRow);
  const notes = paragraphs.filter((text) => !isRow(text));
  if (!rows.length) return;

  const grid = document.createElement('ul');
  grid.className = 'kids-contact-cards';
  grid.setAttribute('role', 'list');

  rows.forEach((text) => {
    const index = text.indexOf(':');
    const label = text.slice(0, index).trim();
    const value = text.slice(index + 1).trim();
    const key = /phone/i.test(label)
      ? 'phone'
      : /mail/i.test(label)
      ? 'email'
      : /address/i.test(label)
      ? 'address'
      : /hour/i.test(label)
      ? 'hours'
      : /response|reply/i.test(label)
      ? 'response'
      : /name/i.test(label)
      ? 'trade'
      : 'other';

    const item = document.createElement('li');
    item.className = `kids-contact-card kids-contact-card--${key}`;

    const icon = document.createElement('span');
    icon.className = 'kids-contact-card__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">${icons[key]}</svg>`;

    const body = document.createElement('div');
    const labelEl = document.createElement('p');
    labelEl.className = 'kids-contact-card__label';
    labelEl.textContent = label;

    let valueEl;
    if (key === 'email') {
      valueEl = document.createElement('a');
      valueEl.href = `mailto:${value}`;
    } else if (key === 'phone') {
      valueEl = document.createElement('a');
      const digits = value.replace(/[^\d+]/g, '');
      valueEl.href = `tel:${digits.startsWith('+') ? digits : `+1${digits}`}`;
    } else {
      valueEl = document.createElement('p');
    }
    valueEl.className = 'kids-contact-card__value';
    valueEl.textContent = value;

    body.append(labelEl, valueEl);
    item.append(icon, body);
    grid.append(item);
  });

  const cta = document.createElement('div');
  cta.className = 'kids-contact-cta';
  cta.innerHTML =
    '<div class="kids-contact-cta__text">' +
    '<p class="kids-contact-cta__title">Still have a question?</p>' +
    '<p class="kids-contact-cta__sub">Sizing, orders or returns \u2014 our team is happy to help.</p>' +
    '</div>' +
    '<a class="kids-contact-cta__button" href="mailto:support@orangekidswear.com">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/></svg>' +
    '<span>Email us</span></a>';

  const children = [grid];
  if (notes.length) {
    const note = document.createElement('div');
    note.className = 'kids-contact-note';
    note.insertAdjacentHTML(
      'beforeend',
      '<svg class="kids-contact-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>'
    );
    const noteText = document.createElement('div');
    notes.forEach((text) => {
      const p = document.createElement('p');
      p.textContent = text;
      noteText.append(p);
    });
    note.append(noteText);
    children.push(note);
  }
  children.push(cta);
  rte.replaceChildren(...children);
  rte.classList.add('kids-contact-rte');
})();
